export class PublicKey {
    equals(other) {
        return this.toString() === other.toString();
    }
}
export class TokenSigner {
}
//# sourceMappingURL=auth.interface.js.map